// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import DocPermissionEditDialog from './DocPermissionEditDialog';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import GroupIcon from '@mui/icons-material/Group';
import Alert from '@mui/material/Alert';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function DocPermissionTab(props) {

  const { sysID, docDetail, disableEdit, afterUpdate } = props;
  // console.log("docDetail", docDetail);

  const rights = docDetail?.Rights || [];

  const [openEditDialog, setOpenEditDialog] = useState(false);

  const vAll = (rights.length == 0) || rights[0].UserOrGroupID == "*";

  // console.log("vAll", vAll);

  const handleAfterUpdate = () => {
    setOpenEditDialog(false);

    afterUpdate && afterUpdate();
  }

  const ShowItem = (aItem) => {
    if (aItem.IsUser === true) {
      return (
        <ListItem >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary={aItem.Name} />
        </ListItem >
      )
    } else {
      return (
        <ListItem >
          <ListItemIcon>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText primary={aItem.Name} />
        </ListItem >
      )
    }
  }

  const handleEditClose = () => {
    // console.log("PermissionEdit close");
    setOpenEditDialog(false);

  }

  return (
    <Box sx={{ flexGrow: 1, height: 1 }}>

      <Box sx={{ py: 1, px: 1 }} >
        <Button disabled={disableEdit} startIcon={<EditIcon />} onClick={() => setOpenEditDialog(true)}>
          Edit
        </Button>
        <DocPermissionEditDialog
          open={openEditDialog}
          onClose={handleEditClose}
          sysID={sysID}
          docDetail={docDetail}
          afterUpdate={handleAfterUpdate}
        />
      </Box>

      {vAll &&
        <Alert severity="success">Everyone who can access the folder</Alert>
      }
      {!vAll &&
        <React.Fragment >

          <Alert severity="info">Limit to the following groups/users:</Alert>
          <Box sx={{ p: 0, height: 1, maxHeight: "60vh", overflow: 'auto' }}>
            <List>
              {rights.map((item, idx) => {
                return (
                  <div key={idx}>
                    {ShowItem(item)}
                  </div>
                );
              })}
            </List>
          </Box>

        </React.Fragment>
      }


    </Box>


  );
}

DocPermissionTab.propTypes = {
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  disableEdit: PropTypes.bool,
  afterUpdate: PropTypes.func,
};
